import { useMutation } from '@apollo/client';
import RegisterMutation from './RegisterMutation';

const RegisterConnectorApollo = ({ children }) => {
  const [register, { data, loading, error }] = useMutation(RegisterMutation);

  const createRegister = async (request) => {
    const response = await register({
      variables: { request },
    });

    return response;
  };

  return children({
    register: createRegister,
    response: data,
    loading,
    error,
  });
};

export default RegisterConnectorApollo;
